module Meevo.Components.LocationPicker {
  export class LocationPickerController {
    context: ILocationPickerContext;

    static $inject = ["$scope",
      "$window",
      "$mdDialog",
      "meevo.AppSettings",
      "meevo.components.common.IdentityService",
        "meevo.components.common.DataService",
        "meevo.components.busy.BusyService",
        "meevo.components.locationPicker.LocationPickerService"];

    constructor(private $scope: any,
      private $window: angular.IWindowService,
      private $mdDialog: angular.material.IDialogService,
      private appSettings: Meevo.Components.Common.IAppSettings,
      private identityService: Meevo.Components.Common.IIdentityService,
      private dataService: Meevo.Components.BaseClasses.IDataService,
      private busyService: Meevo.Components.Busy.IBusyService,
      private locationPickerService: Meevo.Components.LocationPicker.ILocationPickerService) {

        let fn: Function = null;
       
        if (_.isFunction($scope.onSwitchLocation)) {
            fn = $scope.onSwitchLocation;
        }

        this.context = new LocationPickerContext($window, appSettings, identityService, dataService, fn, $scope.enableUserFilter, $scope.excludeCurrentLocation, $scope.isChangeLocation, $scope.excludeCallCenter, busyService, locationPickerService);
       
    }

    close() {
      this.$mdDialog.hide();
    }
    
  }

  angular.module("meevo.components.locationPicker")
    .controller("meevo.components.locationPicker.LocationPickerController", LocationPickerController);
}

